import React, { useState, createContext } from 'react';

const StoreContext = createContext(null);

export const AppContextProvider = ({ children }) => {
  const [queryParam, setQueryParam] = useState(null);
  const [errors, setErrors] = useState({});
  
  const context ={ 
    queryParam, 
    setQueryParam,
    errors,
    setErrors,
  };

  return (
    <StoreContext.Provider value={context}>
         {children}
    </StoreContext.Provider>
  );
};

export default StoreContext;
